import { render, staticRenderFns } from "./FamilyTagsBarChart.vue?vue&type=template&id=653b6698&scoped=true&"
import script from "./FamilyTagsBarChart.vue?vue&type=script&lang=js&"
export * from "./FamilyTagsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b6698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
